import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { PHONE_DISPLAY, PHONE_HREF } from '../data/site';
export function FinalCta() {
  return <section aria-labelledby="final-cta-heading" className="w-full bg-kosin-red" data-id="element-50" data-mp="vgr16v8h9om9">
      <div className="mx-auto flex max-w-shell flex-col gap-6 px-[18px] py-10 sm:px-6 lg:flex-row lg:items-center lg:justify-between lg:py-12" data-id="element-51" data-mp="19fqnhw8iprf9">
        <div data-id="element-52" data-mp="15fq5k1m7my3g">
          <h2 id="final-cta-heading" className="text-[24px] font-bold leading-tight text-white lg:text-[30px]" data-id="element-53" data-mp="1jcvd661ko50t">
            Ready For A Free Estimate?
          </h2>
          <p className="mt-2 text-[16px] text-white/90" data-id="element-54" data-mp="1t2om0zaby61d">
            Tell us about your vehicle, home or building and we’ll take it from
            there.
          </p>
        </div>
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center lg:shrink-0" data-id="element-55" data-mp="223mfwor20x68">
          <a href="#quote" className="focus-light rounded bg-white px-6 py-3.5 text-center text-[16px] font-semibold text-kosin-charcoal hover:bg-kosin-mist transition-colors duration-150 ease-kosin" data-id="element-56" data-mp="221jp42i2v00g">
            Get A Free Quote
          </a>
          <a href={PHONE_HREF} className="focus-light inline-flex items-center justify-center gap-2 rounded border border-white/70 px-6 py-3.5 text-[16px] font-semibold text-white hover:bg-white hover:text-kosin-charcoal transition-colors duration-150 ease-kosin" data-id="element-57" data-mp="s57e724dlmqq">
            <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-58" data-mp="1646thj600pa8" />
            {PHONE_DISPLAY}
          </a>
        </div>
      </div>
    </section>;
}